<template>
  <el-dialog title="Upload" :visible.sync="dialogSwitch" width="600px" :center="true" :close-on-click-modal="false" class="creat-program-tem" @close="cancel">
    <div class="UploadFile" v-if="info.tag == 'tem'">
      <div class="UploadTitle">{{$t('lang.mediaFile')}}</div>
      <upload-file :info="MediaUpload"></upload-file>
    </div>
    <div class="UploadFile" v-if="info.tag == 'tem' || info.tag == 'mcp' ">
      <div class="UploadTitle">{{$t('lang.mcpTiming')}}</div>
      <upload-file :info="TimingUpload"></upload-file>
    </div>
    <div  v-if="info.tag == 'slate'">
      <div class="UploadTitle">Slate</div>
      <upload-file :info="slateUpload"></upload-file>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="cancel" @click="cancel">{{ $t('lang.cancel') }}</el-button>
      <el-button class="save" type="primary" :disabled="disableClick" @click="cancel">{{ $t('lang.save') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import Bus from '@/assets/js/vueBus.js'
import uploadFile from '../uploadFile.vue'
export default {
  props: {
    info: Object
  },
  components: {
    uploadFile
  },
  data () {
    return {
      dialogSwitch: true,
      form: {
        name: '',
        title: ''
      },
      // 模板上传
      TemplateUpload: {
        multiple: false,
        fileType: '.mp4,.mov',
        folderName: '/Playout/Template',
        type: 3
      },
      // media视频上传
      MediaUpload: {
        multiple: true,
        fileType: '.mp4,.mov',
        folderName: '/Playout/Media',
        type: 2
      },
      // timing文件上传
      TimingUpload: {
        multiple: false,
        fileType: '.csv,.xml',
        folderName: '/Playout/Timing',
        type: 3
      },
      // slate文件上传
      slateUpload: {
        multiple: false,
        fileType: '.mp4,.mov,.png',
        folderName: '/Playout/Slate'
      },
      disableClick: true
    }
  },
  created () {
    Bus.$on('refreshFileList', () => {
      this.disableClick = false
    })
  },
  methods: {
    saveInfo () {
      if (this.disableClick) return
      this.cancel()
    },
    cancel () {
      Bus.$emit('openCreatDialog', {
        show: false
      })
    }
  }
}
</script>
<style lang="less" scoped>
.creat-program-tem {
  ::v-deep.el-dialog .el-dialog__body {
    padding-left: 0px;
  }
  .UploadFile {
    margin-bottom: 16px;
    ::v-deep.el-icon-close {
      display: none;
    }
  }
}
</style>
